<template>
    <section class="section bg-primary is-radiusless">
        <div class="container">
            <div class="columns is-mobile">
                <div class="column is-4-desktop is-offset-4-desktop is-6-tablet is-offset-3-tablet is-10-mobile is-offset-1-mobile">
                    <div class="">
                        <div class="has-text-centered mb-4">
                            <img src="/static/img/login_img.png" alt="Tooddoc Logo">
                        </div>

                        <div class="notification is-danger mb-6" v-if="$store.state.formError">
                            <div class="media">
                                <div class="media-left">
                                    <b-icon icon="alert"></b-icon>
                                </div>
                                <div class="media-content">
                                    <p v-text="$store.state.formError"></p>
                                </div>
                            </div>
                        </div>

                        <div id="firebaseui-auth-container" />

                        <router-link
                            v-for="(link, index) in links"
                            :key="index"
                            :to="link.to"
                            :class="link.classes"
                            class="button is-fullwidth mt-2">
                                <span v-text="link.label"></span>
                        </router-link>

                        <button type="button" @click.prevent="logout" class="button is-danger is-fullwidth mt-2" v-if="userId">
                            <span>{{ $t('logout_link_label') }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import firebaseui from 'firebaseui'
import { auth, authProviders } from '@/firebase'
import { store } from '@/store'
import helpers from '@/mixins/helpers'

export default {
    name: 'DoctorHome',

    mixins: [helpers],

    computed: {
        links() {
            var links = []

            if (this.userId) {
                if (this.doctor) {
                    links.push({
                        to: { name: 'doctor.dashboard' },
                        label: this.$t('go_to_doctor_dashboard'),
                        classes: "is-light"
                    })
                } else {
                    links.push({
                        to: { name: 'doctor.register' },
                        label: this.$t('register_as_doctor_link_label'),
                        classes: "is-light"
                    })
                }
            }

            return links
        }
    },

    mounted() {
        // Redirect to the link if there is only one
        if (this.links.length == 1) {
            this.$router.push(this.links[0].to)
        } else {
            let ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(auth)

            ui.start('#firebaseui-auth-container', {
                signInOptions: [
                    authProviders.Email,
                    authProviders.Google,
                    authProviders.Facebook,
                ],
                signInFlow: 'popup',
                credentialHelper: firebaseui.auth.CredentialHelper.NONE,
                signInSuccessUrl: '/doctor'
            })
        }
    },

    methods: {
        logout () {
            store.dispatch('logout', {name: 'doctor.login'})
        }
    }
}
</script>

<style src="@/../node_modules/firebaseui/dist/firebaseui.css"></style>



// WEBPACK FOOTER //
// src/components/Doctor/Home.vue